import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-434f93e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "controls" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
    }, _toDisplayString(_ctx.$localize('move.to.popup.controls.cancel.button')), 1),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('new-folder'))),
      class: "btn"
    }, _hoisted_3),
    _createElementVNode("button", {
      class: _normalizeClass(["btn btn-primary", {'btn-disabled': _ctx.disabledMove}]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveItem && _ctx.moveItem(...args)))
    }, _toDisplayString(_ctx.$localize('move.to.popup.controls.move.button')), 3)
  ]))
}